import {useEffect} from 'react';

import {useLatestRef} from 'lib/hooks/useLatestRef';

import {FILTERED_ATTRIBUTES} from './annotationTextProjection';
import {observeSubtreeChanges} from './annotationUtils';

/**
 * Invokes `handler` once the region's rendered text stops changing — a MathJax
 * rewrite, a translation swap — on the same trailing debounce the paint uses.
 */
export default function useOnRegionSettle(container: Element | null, handler: () => void) {
  // Read through a ref, so a re-created handler cannot discard a settle mid-flight.
  const handlerRef = useLatestRef(handler);

  useEffect(() => {
    if (!container) {
      return undefined;
    }
    return observeSubtreeChanges(
      container,
      {onSettle: () => handlerRef.current()},
      {attributeFilter: FILTERED_ATTRIBUTES}
    );
  }, [container, handlerRef]);
}
